import styled from 'styled-components'

export const Main = styled.main`
    flex: 1;
    background: #eef3fb;
    border-radius: 18px;
    padding: 20px;
    min-height: 500px;
    box-shadow: inset 0 0 0 1px #d8e3f2;
    overflow: hidden;
`

export const SelectedTable = styled.div`
    margin-bottom: 16px;
    font-size: 20px;
    font-weight: 700;
    color: #355486;

    span {
        color: #4a6fb0;
    }
`

export const AddForm = styled.form`
    margin: 20px 0;
    padding: 22px;
    border-radius: 18px;
    background: #ffffff;
    border: 1px solid #dde6f3;
    box-shadow: 0 3px 10px rgba(42, 76, 129, 0.12);
`

export const FormHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 18px;
`

export const FormTitle = styled.h2`
    margin: 0;
    font-size: 22px;
    color: #355486;
`

export const FormSubtitle = styled.p`
    margin: 6px 0 0;
    font-size: 14px;
    color: #6b7fa3;
`

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 16px;
`

export const FormActions = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    padding-top: 18px;
    border-top: 1px solid #e7edf7;
`

export const AddButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 22px;
    border: none;
    border-radius: 14px;
    cursor: pointer;
    background: linear-gradient(135deg, #4a6fb0, #355486);
    color: white;
    font-size: 15px;
    font-weight: 700;
    box-shadow: 0 6px 14px rgba(53, 84, 134, 0.28);
    transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 9px 18px rgba(53, 84, 134, 0.34);
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
        box-shadow: none;
    }
`

export const AddButtonIcon = styled.span`
    font-size: 18px;
    line-height: 1;
`
